function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.02 15.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Giving-History"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Giving-History---Date-Dropdown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Give-Again-Arrow-Copy-3",
    d: "M.18,8.23l7.18,7.18a.6.6,0,0,0,.44.18.6.6,0,0,0,.43-.18L9.84,13.8a.58.58,0,0,0,.18-.43.62.62,0,0,0-.18-.44L4.7,7.8,9.84,2.66A.6.6,0,0,0,10,2.22a.6.6,0,0,0-.18-.43L8.23.18A.6.6,0,0,0,7.8,0a.6.6,0,0,0-.44.18L.18,7.36A.6.6,0,0,0,0,7.8.6.6,0,0,0,.18,8.23Z",
    style: {
      fill: "#2774ae"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.ffcb0d7a86cab2da19c7eb9fe155395f.svg";
export { ForwardRef as ReactComponent };